import React, { FC } from 'react';

import LoadingDisplay from '@nhl/nhl-react-ui/lib/LoadingDisplay';
import ReactTable from '@nhl/nhl-react-ui/lib/NhlTable/ReactTable';

import { useGameWinningGoalsStanleyCupQuery } from '../../../../../redux/ducks/gameWinningGoals';

import columnDefinitions from './columnDefinitions';

const DEFAULT_SORT = [{ id: 'seasonId', desc: true }];

const GameWinningGoals: FC = () => {
    const { data = [], isFetching } = useGameWinningGoalsStanleyCupQuery({});
    return (
        <LoadingDisplay isLoading={isFetching}>
            <ReactTable
                className="table-layout-table -striped -highlight"
                columns={columnDefinitions}
                data={data}
                pageSize={data.length}
                defaultSorted={DEFAULT_SORT}
                showPagination={false}
            />
        </LoadingDisplay>
    );
};

export default GameWinningGoals;
